var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCollapsible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 13.816L20.308 27.52L15.22 22.432L16.912 20.74L20.308 24.136L32.308 12.136L34 13.816ZM31.348 19.864C31.504 20.548 31.6 21.268 31.6 22C31.6 27.304 27.304 31.6 22 31.6C16.696 31.6 12.4 27.304 12.4 22C12.4 16.696 16.696 12.4 22 12.4C23.896 12.4 25.648 12.952 27.136 13.9L28.864 12.172C26.92 10.804 24.556 10 22 10C15.376 10 10 15.376 10 22C10 28.624 15.376 34 22 34C28.624 34 34 28.624 34 22C34 20.572 33.736 19.204 33.28 17.932L31.348 19.864Z",
    fill: "#00BEC1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCollapsible);
export default __webpack_public_path__ + "static/media/checkCollapsible.c8f35e88.svg";
export { ForwardRef as ReactComponent };